import React from "react";

import qrcode from "./qr-code.png"

function Qr(){
    return(
        <div className=" flex justify-center mb-10">
            <img src={qrcode}
                className="h-[150px]"
            />
        </div>
    )
}

export default Qr;